// -*-mode: rjsx -*-
// REACT
import React, { useState, useEffect } from "react"
// eslint-disable-next-line
import clsx from "clsx"
// UTILS
// eslint-disable-next-line
import * as _ from "lodash"
// eslint-disable-next-line
import tinycolor from "tinycolor2"

// MUI
import { makeStyles } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import Paper from "@material-ui/core/Paper"
import UncheckedCircle from '@material-ui/icons/RadioButtonUnchecked'
import CheckedCircle from "@material-ui/icons/CheckCircle"
import Checkbox from "@material-ui/core/Checkbox"


// COLORS
// eslint-disable-next-line
import lime from "@material-ui/core/colors/lime"
// eslint-disable-next-line
import grey from "@material-ui/core/colors/grey"


// FLASH
// eslint-disable-next-line
import { globalStyles, useGlobalStyles } from "../FlashStyles.js"
import FlashItem from "../Flash/FlashItem.js"

const useDefaultStyles = makeStyles(theme => ({
    root: {
        // mobile
        margin: 0,
        maxWidth: "100%",
        padding: 10,
        paddingTop: 10,
        paddingBottom: 10,
//        maxHeight: 56,
        overflow: "hidden",
        cursor: "pointer",
        userSelect: "none",
        backgroundColor: "#FFFFFF",

        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            marginBottom: 0,
            borderBottom: "1px solid",
            borderBottomColor: grey[200],
	    borderRadius: 0,
        },

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
//            marginTop: 15,
            borderRadius: 3,
        },
        
    },

    checkedCircle: {
        ...theme.css.checkedCircle,
        fontSize: 50,
    },

    uncheckedCircle: {
        ...theme.css.uncheckedCircle,
        // fontSize: 50,
    },

}), { name: "FlashCard" })

let FlashCard = (props) => {

    // eslint-disable-next-line
    const { children, style, text, className,
            // eslint-disable-next-line
            hasMore = true,
            // eslint-disable-next-line
            hasLess = true,
            // eslint-disable-next-line
            clickBody = false,
          } = props

    const classes = {
        ...useDefaultStyles(),
        ...className,
    }

    // DEBUG only
    // eslint-disable-next-line
    const [isDebugLayout, setDebugLayout] = useState(false)

    useEffect(() => {
    })

    // we use style from props to set the root style to this div
    return (
        <Paper className={classes.root}>
          <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
        <FlashItem
        //            className={{root: classes.rootOverride,
//                        rootExpanded: classes.rootExpandedOverride,
//                       }}
            clickBody={true}
            hasLess={true}
            hasMore={true}
          >
        <Typography variant="subtitle2" style={{marginLeft: 20, fontSize: 18, fontWeight: 400 }}>
          {text}
        </Typography>

        </FlashItem>
              <Checkbox
                icon={<UncheckedCircle className={classes.uncheckedCircle}/>}
                checkedIcon={<CheckedCircle className={classes.checkedCircle}/>}
//                onChange={this.handleCheckboxChange(value.uuid)}
//                checked={value.isChecked}
              />

          </div>
        </Paper>
    )
}

export default FlashCard
